import { render, staticRenderFns } from "./Qbbbook.vue?vue&type=template&id=286fe638&scoped=true&"
import script from "./Qbbbook.vue?vue&type=script&lang=js&"
export * from "./Qbbbook.vue?vue&type=script&lang=js&"
import style0 from "./Qbbbook.vue?vue&type=style&index=0&id=286fe638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286fe638",
  null
  
)

export default component.exports